// todo move to redux or polymer
export const EMPTY_THUMBNAIL = 'EmptyThumbnail';

export const DEFAULT_ORDER_NUMBER = 0;
